const initialState = {
  actionProcessing: false,
  coupons: {
    items: [],
    count: 0,
  },
  bets: null,
};

export default initialState
